import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_DiseaseProfile } from '@app/dp-frontend';
import { ConfigKeyFE_ComplaintsTagId, ConfigKeyFE_DiseasesTagId, ConfigKeyFE_SourceTagId, ModuleFE_Variable, MultiSelect_Variable } from '@app/hcs-frontend';
import { Const_ChiefComplaint, Const_DifferentialDiagnosis, Const_OrderSet, Const_Treatment, Const_Triage, pathwayType_SingleState } from '@app/pathway-shared';
import { Button, LL_H_C } from '@nu-art/thunderstorm-frontend';
import { dbObjectToId } from '@nu-art/ts-common';
import { UtilObject_DiseaseProfile } from '@app/dp-frontend/search/index';
import { useEffect, useState } from 'react';
const calculateAllowedVariableIds = (pathwayType) => {
    switch (pathwayType) {
        case pathwayType_SingleState:
        case Const_DifferentialDiagnosis:
        case Const_Treatment: {
            const viableVariableIds = ModuleFE_DiseaseProfile.cache.map(dp => dp.variableId);
            const sourceTagId = ConfigKeyFE_SourceTagId.get();
            const tagId = ConfigKeyFE_DiseasesTagId.get();
            return ModuleFE_Variable.cache.filter(variable => {
                if (!viableVariableIds.includes(variable._id))
                    return false;
                const sourceGroup = variable.tagIds.find(group => group.key === sourceTagId);
                return !!sourceGroup?.value.includes(tagId);
            }).map(dbObjectToId);
        }
        case Const_ChiefComplaint:
        case Const_OrderSet:
        case Const_Triage: {
            const sourceTagId = ConfigKeyFE_SourceTagId.get();
            const tagId = ConfigKeyFE_ComplaintsTagId.get();
            return ModuleFE_Variable.cache.filter(variable => {
                const sourceGroup = variable.tagIds.find(group => group.key === sourceTagId);
                return !!sourceGroup?.value.includes(tagId);
            }).map(dbObjectToId);
        }
        default:
            return [];
    }
};
export const Editor_PathwayDiseases_Modules = [ModuleFE_Variable, ModuleFE_DiseaseProfile];
export const Editor_PathwayDiseases = (props) => {
    const [allowedVarIds, setAllowedVarIds] = useState([]);
    useEffect(() => {
        setAllowedVarIds(calculateAllowedVariableIds(props.pathway.item.type));
    }, [props.pathway.item.type]);
    // View mode mirrors the Orders list (Renderer_PathwayActions): each associated disease is a clickable
    // button that opens its Disease Profile tab. Variables without a Disease Profile (e.g. complaints on
    // ChiefComplaint/OrderSet/Triage pathways) render as plain text since there's no tab to open.
    if (!props.editMode)
        return _jsx(LL_H_C, { className: 'e__pathway__diseases', children: (props.pathway.item.variableIds ?? []).map(variableId => {
                const variable = ModuleFE_Variable.cache.unique(variableId);
                const diseaseProfile = ModuleFE_DiseaseProfile.cache.find(dp => dp.variableId === variableId);
                const label = variable?.name ?? 'Unknown';
                return diseaseProfile
                    ? _jsx(Button, { variant: 'text', onClick: () => UtilObject_DiseaseProfile.openEditor(diseaseProfile), children: label }, variableId)
                    : _jsx("span", { children: label }, variableId);
            }) });
    return _jsx(MultiSelect_Variable, { editable: props.pathway, itemsDirection: 'horizontal', prop: 'variableIds', disabled: !props.editMode, itemFilter: id => allowedVarIds.includes(id) });
};
//# sourceMappingURL=Editor_PathwayDiseases.js.map